import { z } from "zod";
import { AgencyIdSchema } from "../primitives/ids.js";
export const AgencyStudioTeamMemberV1Schema = z
    .object({
    email: z.string().email(),
    roleLabel: z.string().min(1).max(80),
})
    .strict();
export const AgencyStudioIntegrationV1Schema = z
    .object({
    integrationId: z.enum(["EMAIL_SENDER", "CUSTOM_DOMAIN", "CRM_WEBHOOK"]),
    status: z.enum(["NOT_CONFIGURED", "CONFIGURED", "DEFERRED"]),
    note: z.string().max(240).optional(),
})
    .strict();
export const AgencyStudioOnboardingViewV1Schema = z
    .object({
    schemaId: z.literal("agency.studioOnboarding.v1"),
    agencyId: AgencyIdSchema,
    displayName: z.string().min(1).max(120),
    brandPrimaryColor: z.string().regex(/^#[0-9A-Fa-f]{6}$/),
    ownerDisplayName: z.string().min(1).max(120),
    teamMembers: z.array(AgencyStudioTeamMemberV1Schema).max(24),
    integrations: z.array(AgencyStudioIntegrationV1Schema).min(1),
    onboardingWizardCompleted: z.boolean(),
    updatedAt: z.string().datetime(),
})
    .strict();
export const AgencyStudioOnboardingUpsertV1Schema = z
    .object({
    schemaVersion: z.literal("agency-studio-onboarding-upsert.v1.0"),
    displayName: z.string().min(1).max(120),
    brandPrimaryColor: z.string().regex(/^#[0-9A-Fa-f]{6}$/),
    ownerDisplayName: z.string().min(1).max(120),
    teamMembers: z.array(AgencyStudioTeamMemberV1Schema).max(24),
    integrations: z.array(AgencyStudioIntegrationV1Schema).min(1),
    onboardingWizardCompleted: z.boolean(),
})
    .strict();
export const DEFAULT_AGENCY_STUDIO_INTEGRATIONS = [
    { integrationId: "EMAIL_SENDER", status: "NOT_CONFIGURED" },
    { integrationId: "CUSTOM_DOMAIN", status: "NOT_CONFIGURED" },
    { integrationId: "CRM_WEBHOOK", status: "NOT_CONFIGURED" },
];
export function validateAgencyStudioOnboardingConfig(input) {
    const parsed = AgencyStudioOnboardingUpsertV1Schema.safeParse(input);
    if (!parsed.success)
        return { ok: false, reason: "invalid_shape" };
    const emails = new Set();
    for (const member of parsed.data.teamMembers) {
        const key = member.email.toLowerCase();
        if (emails.has(key))
            return { ok: false, reason: "duplicate_team_email" };
        emails.add(key);
    }
    const integrationIds = new Set(parsed.data.integrations.map((row) => row.integrationId));
    if (integrationIds.size !== parsed.data.integrations.length) {
        return { ok: false, reason: "duplicate_integration" };
    }
    return { ok: true };
}
//# sourceMappingURL=agency-studio-onboarding.js.map